import { Workflow } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const workflowTypeOptions: ComboboxFilterOption<string>[] = [
  { label: 'Submission', value: 'submission' },
  { label: 'Renewal', value: 'renewal' },
  { label: 'Plan Change', value: 'plan_change' },
  { label: 'Dependent Change', value: 'dependent_change' },
  { label: 'Plan Change & Dependent Change', value: 'plan_change_and_dependent_change' },
  { label: 'Off Thatch', value: 'off_thatch' },
  { label: 'Cancellation', value: 'cancellation' },
  { label: 'Offboarding', value: 'offboarding' },
]

const WorkflowsTypeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = workflowTypeOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Type', options: filteredOptions || [] }]}
        placeholder='Search workflow types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={workflowTypeOptions || []}
          noSelectionText='Workflow Type'
          pluralIdentifier='workflow types'
        >
          <Workflow size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default WorkflowsTypeFilter
